<template lang="pug">
.message-history-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :filter-included-fields="filterFields"
    :busy="isBusy"
    no-border-collapse
    table-class="basic-table nohead-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません。
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません。

    // セル：メッセージ
    // tableライブラリは使用するが、見た目はtableではないようにする
    template(#cell(message)="row")
      .message-history-row(@click="onDetail(row.item)")
        .d-flex.flex-row.align-items-center
          .flex-grow-1
            .mb-1
              img.mr-2(v-show="row.item.replyUnread" src="@/assets/sidemenu-sendmessage-incoming.png")
              span {{ getDisplayDate(row.item) }}（{{ getSenderType(row.item) }}）
            .mb-0.message-receivers 宛先：{{ row.item.receivers  }}
            .mb-0.message-title {{ row.item.functionContents.title }}
          .buttons.svg-icon
            .angle-right
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SendMessageFunction } from "@/commons/models/Message";
import { SenderType } from "@/commons/models/Resident";
import { LineReceiverDetail } from "@/commons/models/SendLineMessage";

/**
 * ### メッセージ送信[履歴]テーブルコンポーネント
 */
@Component({})
export default class MessageHistoryTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<MessageHistoryTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<MessageHistoryTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isBusy!: boolean;
  /** フィルター */
  @Prop()
  filter!: any;
  /** フィルター対象カラム */
  @Prop()
  filterFields!: string[];

  get _value(): Array<MessageHistoryTableItem> {
    return this.value;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: MessageHistoryTableItem): boolean {
    if (row.writerId == this.filter) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 送信手段の文字列を返す
   */
  public getSenderType(message: MessageHistoryTableItem): string {
    if (message.senderType == SenderType.LINE) {
      return "LINE";
    } else if (message.senderType == SenderType.MAIL) {
      return "メール";
    } else {
      return "";
    }
  }

  /**
   * ### 画面表示用の日付を返す
   */
  public getDisplayDate(message: MessageHistoryTableItem): string {
    if (message.datetime) {
      return this.$dateUtil.convertNumberToString(Number(message.datetime), "mm月dd日 hh:MM");
    } else {
      return "";
    }
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onDetail(item: MessageHistoryTableItem): void {
    this.$emit("onDetail", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface MessageHistoryTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface MessageHistoryTableItem {
  facilityId: number;
  senderType: SenderType;
  datetime: number;
  receivers: string;
  functionContents: SendMessageFunction;
  writerId: string;
  writtenBy: string;
  unreadCount?: number;
  replyUnread?: boolean;
  receiverDetails: Array<LineReceiverDetail>;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/mobile/_mixin.scss";
@import "../../../styles/mobile/_colors.scss";

.message-history-table-component {
  .svg-icon {
    width: 16px;
    height: 16px;
    margin-left: -6px;
    .angle-right {
      @include svg-icon("../../../assets/angle-right.svg", $font-base, 18px, 18px);
    }
  }

  .message-title {
    font-weight: bold;
  }
  .buttons {
    .angle-right {
      color: $font-base;
    }
  }
}
</style>
